<script>
export default {
  props: {},
  methods: {},
}
</script>

<template>
  <div class="overlay--container">
    <div>
      <img
        src="https://vanished-fe.s3.us-east-2.amazonaws.com/mantle-loader-2.gif"
        alt="spinner"
      />
      <h4>Connection Initializing...</h4>
    </div>
  </div>
</template>

<style lang="scss">
@import '@design';

.overlay--container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 4rem;
  > div {
    margin: 0 auto;
    text-align: center;
    img {
      width: 50px;
      opacity: 0.8;
    }
  }
  h4 {
    padding-top: 1rem;
    margin: 0 auto;
  }
  .loading {
    margin-top: 1.5rem;
    font-size: 18px;
  }

  .loading::after {
    display: inline-block;
    width: 0;
    overflow: hidden;
    vertical-align: bottom;
    content: '\2026'; /* ascii code for the ellipsis character */
    -webkit-animation: ellipsis steps(4, end) 1s infinite;
    animation: ellipsis steps(4, end) 1s infinite;
  }

  @keyframes ellipsis {
    to {
      width: 1.25em;
    }
  }

  @-webkit-keyframes ellipsis {
    to {
      width: 1.25em;
    }
  }
}
</style>
